export const INTAKE_WIZARD_TYPES = {
    accident: {
        i18nPrefix: 'pages.intake',
        steps: [
            { key: 'aboutYou' },
            { key: 'whatHappened' },
            { key: 'howYouFelt' },
            { key: 'symptomsToday' },
            { key: 'symptomDetails', dataKey: 'symptomsToday', skipUnlessComplaints: true },
            { key: 'healthScreening' },
            { key: 'treatmentReceived' },
            { key: 'treatingProviders' },
            { key: 'testsImaging' },
            { key: 'previousInjuries' },
            { key: 'medicalSurgical' },
            { key: 'medicationsAllergies' },
            { key: 'workInformation' },
            { key: 'socialFamily' },
            { key: 'dailyActivities' },
            { key: 'healthQuestions' },
            { key: 'reviewSubmit', isReview: true },
            { key: 'confirmSubmit', isConfirm: true },
        ],
    },
    general: {
        i18nPrefix: 'pages.intake.general',
        steps: [
            { key: 'aboutYou' },
            { key: 'symptomsToday' },
            { key: 'healthScreening' },
            { key: 'treatmentReceived' },
            { key: 'treatingProviders' },
            { key: 'testsImaging' },
            { key: 'medicalSurgical' },
            { key: 'medicationsAllergies' },
            { key: 'socialFamily' },
            { key: 'dailyActivities' },
            { key: 'preventiveCare' },
            { key: 'healthQuestions' },
            { key: 'reviewSubmit', isReview: true, reviewVariant: 'general' },
            { key: 'confirmSubmit', isConfirm: true },
        ],
    },
}

export function getIntakeWizardConfig(type) {
    return INTAKE_WIZARD_TYPES[type] || INTAKE_WIZARD_TYPES.accident
}

export function createEmptyFormData(steps, aboutYouPrefill) {
    return steps.reduce((formData, step) => {
        const key = step.dataKey || step.key
        if (Object.prototype.hasOwnProperty.call(formData, key)) {
            return formData
        }

        formData[key] = key === 'aboutYou' ? aboutYouPrefill : undefined
        return formData
    }, {})
}
